// Component for editing an outfit
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';

const EditOutfit = () => {
    const [clothes, setClothes] = useState([]); // Store available clothes
    const [formData, setFormData] = useState({
        outfit_name: '',
        occasion: '',
        clothing_items: []
    });

    // Search state variables
    const [clothNameSearchTerm, setClothNameSearchTerm] = useState('');
    const [categorySearchTerm, setCategorySearchTerm] = useState('');
    const [colorSearchTerm, setColorSearchTerm] = useState('');
    const [seasonSearchTerm, setSeasonSearchTerm] = useState('');

    const navigate = useNavigate();
    const { id } = useParams();

    useEffect(() => {
        fetchOutfit(); // Load outfit data
        fetchClothes(); // Load available clothes
    }, []);

    const fetchOutfit = async () => {
        try {
            const response = await axios.get(`http://localhost:3000/api/outfits/${id}`, {
                headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
            });
            const outfit = response.data;
            setFormData({
                outfit_name: outfit.outfit_name,
                occasion: outfit.occasion.join(', '),
                clothing_items: outfit.clothing_items.map(item => item._id)
            });
        } catch (error) {
            console.error('Error fetching outfit:', error.response ? error.response.data : error.message);
        }
    };

    const fetchClothes = async () => {
        try {
            const response = await axios.get('http://localhost:3000/api/clothes', {
                headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
            });
            setClothes(response.data);
        } catch (error) {
            console.error('Error fetching clothes:', error.response ? error.response.data : error.message);
        }
    };    

    const handleClothSelect = (clothId) => {
        setFormData(prevData => ({
            ...prevData,
            clothing_items: prevData.clothing_items.includes(clothId)
                ? prevData.clothing_items.filter(id => id !== clothId)
                : [...prevData.clothing_items, clothId]
        }));
    };

    const isSelected = (clothId) => formData.clothing_items.includes(clothId);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevData => ({
            ...prevData,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const updatedOutfit = {
            outfit_name: formData.outfit_name,
            occasion: formData.occasion.split(',').map(occ => occ.trim()),
            clothing_items: formData.clothing_items
        };

        try {
            await axios.put(`http://localhost:3000/api/outfits/${id}`, updatedOutfit, {
                headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
            });
            navigate('/outfits');  // Redirect to Outfits page after update
        } catch (error) {
            console.error('Error updating outfit:', error.response ? error.response.data : error.message);
            alert('Error updating outfit. Please try again.');
        }
    };

    // Filter clothes based on search terms
    const filteredClothes = clothes.filter(cloth => {
        const matchesClothName = cloth.cloth_name.toLowerCase().includes(clothNameSearchTerm.toLowerCase());
        const matchesCategory = cloth.category.some(cat => cat.toLowerCase().includes(categorySearchTerm.toLowerCase()));
        const matchesColor = cloth.color.some(col => col.toLowerCase().includes(colorSearchTerm.toLowerCase()));
        const matchesSeason = cloth.season.some(sea => sea.toLowerCase().includes(seasonSearchTerm.toLowerCase()));

        return matchesClothName && matchesCategory && matchesColor && matchesSeason;
    });

    return (
        <div className="edit-outfit-container">
            <h1><strong>𝐸𝒹𝒾𝓉 𝒪𝓊𝓉𝒻𝒾𝓉</strong></h1>
            <form onSubmit={handleSubmit}>
                <label>
                    <strong>Outfit Name:</strong>
                    <input
                        type="text"
                        name="outfit_name"
                        value={formData.outfit_name}
                        onChange={handleChange}
                        placeholder="Enter outfit name"
                    />
                </label>
                <label>
                    <strong>Activity\-ies:</strong>
                    <input
                        type="text"
                        name="occasion"
                        value={formData.occasion}
                        onChange={handleChange}
                        placeholder="e.g. Coffee, Gym (separate with commas)"
                    />
                </label>

                <div className="search-filters">
                    <h4><strong>𝒮𝑒𝒶𝓇𝒸𝒽 & 𝒮𝑒𝓁𝑒𝒸𝓉 𝒞𝓁𝑜𝓉𝒽𝑒𝓈:</strong></h4>
                    <input
                        type="text"
                        placeholder="Search by cloth name"
                        value={clothNameSearchTerm}
                        onChange={(e) => setClothNameSearchTerm(e.target.value)}
                    />
                    <input
                        type="text"
                        placeholder="Search by category"
                        value={categorySearchTerm}
                        onChange={(e) => setCategorySearchTerm(e.target.value)}
                    />
                    <input
                        type="text"
                        placeholder="Search by color"
                        value={colorSearchTerm}
                        onChange={(e) => setColorSearchTerm(e.target.value)}
                    />
                    <input
                        type="text"
                        placeholder="Search by season"
                        value={seasonSearchTerm}
                        onChange={(e) => setSeasonSearchTerm(e.target.value)}
                    />
                </div>

                <div className="clothing-list">
                    {filteredClothes.map((cloth) => (
                        <div key={cloth._id} 
                            className={`clothing-item ${isSelected(cloth._id) ? 'selected' : ''}`}
                            onClick={() => handleClothSelect(cloth._id)}>
                            <img crossorigin="anonymous" src={`http://localhost:3000/${cloth.image_url}`} alt={cloth.cloth_name} />
                            <label>{cloth.cloth_name}</label>
                        </div>
                    ))}
                </div>

                <button type="submit" className="update-btn"><i class="fa-solid fa-upload"></i> <strong>𝒰𝓅𝒹𝒶𝓉𝑒</strong></button>
            </form>
        </div>
    );
};

export default EditOutfit;